import { Router } from '@/app/routes';
import { LoginButton, useAuth, useSessionSync } from '@/features/auth';
import { LoadingScreen, MainLayout } from '@/shared/ui';

function App() {
  const auth = useAuth();
  useSessionSync();

  if (auth.isLoading) {
    return <LoadingScreen />;
  }

  if (!auth.isAuthenticated) {
    return <LoginButton onClick={() => void auth.signinRedirect()} />;
  }

  return (
    <MainLayout>
      <Router />
    </MainLayout>
  );
}

export default App;
